// redux/prjtasks/prjtasks.reducer.js
import prjtaskActionTypes from "./prjtasks.types";

const INITIAL_STATE = {
  prjtasks: [],
};

const prjtaskReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case prjtaskActionTypes.SET_PRJTASKS:
      return {
        ...state,
        prjtasks: action.payload,
      };
    default:
      return state;
  }
};

export default prjtaskReducer;
